export default __webpack_public_path__ + "static/media/Ambulance.3416ef77.webp";